import { useEffect, useRef } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";


export default function MP(props: any) {
  
  const center = {lat: 13.722412263070936, lng: 100.52349829612974 };
  
  return (
    <Wrapper apiKey={props.mapKey} libraries={["marker"]}>
      <MapComponent 
        center={center} 
        zoom={14} 
        mapId={props.mapId} 
        data={[]}
      />
    </Wrapper>
  )
}

function MapComponent({center, zoom, mapId, data}: {
  center: google.maps.LatLngLiteral,
  zoom: number,
  mapId: string,
  data: any[]
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let draw = async () => {
      let map = new google.maps.Map(ref.current!, {
        center,
        zoom,
        mapId
      });
      for (const item of data) {
        let { name, lat, lng } = item;
        let marker = new google.maps.marker.AdvancedMarkerElement({
          map: map,
          position: {lat, lng},
          title: name,
          content: (new google.maps.marker.PinElement({
            glyph: name, glyphColor: "green", background: "white"})).element
        });
      }
      
    }
    draw();
  }, []);

  return <div ref={ref} style={{height: "100vh", width: "100%"}} id="map" />;
}
